import React from 'react';
import { Snackbar, Alert, AlertColor } from '@mui/material';

interface GlobalSnackbarProps {
  open: boolean;
  message: string;
  type: 'success' | 'error';
  onClose: () => void;
}

const GlobalSnackbar: React.FC<GlobalSnackbarProps> = ({
  open,
  message,
  type,
  onClose,
}) => {
  const handleClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    onClose();
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      style={{ zIndex: 999999999999999 }}
    >
      <Alert
        severity={type as AlertColor}
        variant="filled"
        sx={{
          width: '100%',
          minWidth: '300px',
          boxShadow: 3,
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default GlobalSnackbar;
